import { ROUTES } from '../../utils/constants';

const isChildSpecificRoute = (href) => (
  typeof href === 'string' && href.includes(':studentId')
);

export const filterParentNavigationItems = (
  menuItems,
  { currentRole, linkedChildren }
) => {
  if (!Array.isArray(menuItems) || currentRole !== 'parent' || linkedChildren?.length > 0) {
    return menuItems;
  }

  return menuItems.reduce((visibleItems, item) => {
    if (isChildSpecificRoute(item?.href)) return visibleItems;

    if (!Array.isArray(item?.children)) {
      visibleItems.push(item);
      return visibleItems;
    }

    const visibleChildren = filterParentNavigationItems(item.children, {
      currentRole,
      linkedChildren,
    });

    if (item.children.length > 0 && visibleChildren.length === 0 && !item.href) {
      return visibleItems;
    }

    visibleItems.push(
      visibleChildren === item.children
        ? item
        : { ...item, children: visibleChildren }
    );
    return visibleItems;
  }, []);
};

export const resolveParentNavigationHref = (
  href,
  { currentRole, linkedChildren, hasLoadedChildren }
) => {
  if (!href || currentRole !== 'parent' || !isChildSpecificRoute(href)) {
    return href;
  }

  const firstChildId = linkedChildren?.[0]?.studentId;
  if (firstChildId) return href.replace(':studentId', firstChildId);
  if (hasLoadedChildren) return ROUTES.PARENT_LINKING;
  return href;
};

export const shouldRedirectUnlinkedParent = ({
  currentRole,
  linkedChildren,
  hasLoadedChildren,
}) => (
  currentRole === 'parent'
  && hasLoadedChildren === true
  && linkedChildren?.length === 0
);
